<template>
  <div class="editor-wrap">
    <div class="editor-con" @dblclick="handleImgView()">
      <!-- 工具栏 -->
      <Toolbar
        :style="showToolbarBorder ? 'border-bottom: 1px solid #E5E6E8' : ''"
        :class="{ isComment }"
        :editor="editorId"
        :defaultConfig="toolbarConfig"
      />
      <div class="button-wrap wrap-top" v-if="showTop">
        <span class="cancel text-btn-active" @click="handleCancel" style="margin-right:30px;">取消</span>
        <wf-button type="primary" @click="handleSubmit" :disabled="isTaskDetail === true ? false : hasConLock">{{ confirmText }}</wf-button>
      </div>
      <!-- 编辑器 -->
      <Editor
        :style="{ height, 'min-height': minHeight || '200px' }"
        :defaultConfig="editorConfig"
        :defaultContent="getDefaultContent"
        @onCreated="onCreated"
        @onChange="onChange"
        ref="editor"
        @onBlur="onBlur"
      />

      <!-- @ 提及插件 -->
      <Mention-modal
        v-if="isShowModal"
        :projectId="projectId"
        @hideMentionModal="hideMentionModal"
        @insertMention="insertMention"
      ></Mention-modal>
    </div>

    <div class="button-wrap wrap-bottom" v-if="showBtn && !showTop">
      <span class="cancel text-btn-active" @click="handleCancel" style="margin-right:30px;">取消</span>
      <wf-button type="primary" @click="handleSubmit" :disabled="isTaskDetail === true ? false : hasConLock" :loading="loading">{{ confirmText }}</wf-button>
    </div>
  </div>
</template>

<script>
import { Boot } from '@wangeditor/editor'
import { Editor, Toolbar, removeEditor } from "@wangeditor/editor-for-vue";
import cloneDeep from "lodash.clonedeep";
import mentionModule from '@wangeditor/plugin-mention'

import MentionModal from './components/mentionModal/index.vue'
import { CustomMenu } from './components/mentionModal/customMenu'

import uploadApi from "@/services/api/upload/upload";
import axios from "axios";
axios.defaults.withCredentials = false;
axios.defaults.crossDomain = true;
let instance = axios.create({});

// 注册插件
Boot.registerModule(mentionModule)

// 注册自定义菜单
const customMenuConf = {
  key: 'customMenu1', // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new CustomMenu()
  },
}
Boot.registerMenu(customMenuConf)

export default {
  name: "MyEditor",
  components: { Editor, Toolbar, MentionModal },
  props: {
    toolbarObj: {
      type: Array,
      default: () => {
        return [
          "headerSelect",
          "bulletedList",
          "numberedList",
          {
            key: "group-more-justify", // 必填，要以 group 开头
            title: "更多样式", // 必填
            iconSvg:
              '<svg t="1639452817598" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10725" width="128" height="128"><path d="M723.2 357.504c6.4 0 12.8 0 19.2 6.4l153.6 128c6.4 6.4 6.4 25.6 0 38.4l-6.4 6.4-153.6 128c-12.8 6.4-25.6 6.4-38.4-6.4-6.4-6.4-6.4-12.8-6.4-19.2v-64H192c-32 0-57.6-25.6-64-57.6v-6.4c0-38.4 25.6-64 64-64h505.6v-64c0-12.8 6.4-25.6 25.6-25.6zM576 127.104H192c-38.4 0-64 25.6-64 64s25.6 64 64 64h384c38.4 0 64-25.6 64-64 0-32-25.6-64-64-64zM576 767.104H192c-38.4 0-64 25.6-64 64s25.6 64 64 64h384c38.4 0 64-25.6 64-64 0-32-25.6-64-64-64z" p-id="10726"></path></svg>', // 可选
            menuKeys: ["justifyLeft", "justifyRight", "justifyCenter", "justifyJustify"], // 下级菜单 key ，必填
          },
          "uploadImage",
          "divider",
          "undo",
          "redo",
        ]
      }
    },
    // 项目id
    projectId: {
      type: Number,
      default: 0
    },
    // 是否为评论引用
    isComment: {
      type: Boolean,
      default: false
    },
    // 按钮显示在工具栏
    showTop: Boolean,
    //初始化显示已有内容，回显使用  (必须得是符合富文本编辑器的数据结构转换的str)
    textInfo: {
      type: String,
      default: '[{"type":"paragraph","children":[{"text":""}]}]',
    },
    //编辑器高度
    height: {
      type: String,
      default: "auto",
    },
    minHeight: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: "保 存",
    },
    placeholder: {
      type: String,
      default: "请输入内容...",
    },
    // 是否工具栏加下边框
    showToolbarBorder: {
      type: Boolean,
      default: true
    },
    //判断是否显示按钮框
    showBtn: {
      type: Boolean,
      default: true,
    },
    //判断是否任务详情页的富文本字段调用的编辑器组件
    isTaskDetail: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false
    }
    // propsEditorId: { //富文本编辑器ID，用以区分引用编辑器、防止多个富文本同时出现bug
    //   type: String,
    //   default: 'wangEditor-1'
    // }
  },
  data() {
    const _ts = this;
    return {
      fileType: ["jpg", "jpeg", "png", "bmp", "gif", "svg"],
      fileTypeLock: false,
      hasConLock: true,
      isShowModal: false,
      urlList: [],
      count: 0,
      // editorId: _ts.propsEditorId, // 定义一个编辑器 id ，要求：全局唯一且不变。重要！！！
      editorId: null, // 定义一个编辑器 id ，要求：全局唯一且不变。重要！！！
      defaultContent: JSON.parse(_ts.textInfo), // 编辑器的默认内容，只在初始化时使用
      latestContent: [
        // 用于存储编辑器最新的内容，onChange 时修改
        {
          children: [{ text: "" }],
        },
      ],
      toolbarConfig: {
        toolbarKeys: _ts.toolbarObj,
        // 默认所有菜单栏列表
        // toolbarKeys: [
        //   "headerSelect", // 标题
        //   "blockquote", // 引用
        //   "|",
        //   "bold", // 加粗
        //   "underline", // 下划线
        //   "italic", // 斜体
        //   {
        //       "key": "group-more-style",
        //       "title": "更多",
        //       "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path></svg>",
        //       "menuKeys": [
        //           "through", // 删除线
        //           "code", // 行内代码
        //           "sup", // 上标
        //           "sub", // 下标
        //           "clearStyle" // 清楚格式
        //       ]
        //   },
        //   "color", // 文字颜色
        //   "bgColor", // 背景颜色
        //   "|",
        //   "fontSize", // 字体大小
        //   "fontFamily", // 字体
        //   "lineHeight", // 行高
        //   "|",
        //   "bulletedList", // 无序列表
        //   "numberedList", // 有序列表
        //   "todo", // 待办
        //   {
        //       "key": "group-justify",
        //       "title": "对齐",
        //       "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z\"></path></svg>",
        //       "menuKeys": [
        //           "justifyLeft", // 左对齐
        //           "justifyRight", // 右对齐
        //           "justifyCenter", // 居中对齐
        //           "justifyJustify" // 两端对齐
        //       ]
        //   },
        //   {
        //       "key": "group-indent",
        //       "title": "缩进",
        //       "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z\"></path></svg>",
        //       "menuKeys": [
        //           "indent", // 增加缩进
        //           "delIndent" // 减少缩进
        //       ]
        //   },
        //   "|",
        //   "emotion", // 表情
        //   "insertLink", // 插入链接
        //   {
        //       "key": "group-image",
        //       "title": "图片",
        //       "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z\"></path></svg>",
        //       "menuKeys": [
        //           "insertImage", // 网络图片
        //           "uploadImage" // 上传图片
        //       ]
        //   },
        //   {
        //       "key": "group-video",
        //       "title": "视频",
        //       "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z\"></path></svg>",
        //       "menuKeys": [
        //           "insertVideo", // 插入视频
        //           "uploadVideo" // 上传视频
        //       ]
        //   },
        //   "insertTable", // 插入表格
        //   "codeBlock", // 代码块
        //   "divider", // 分割线
        //   "|",
        //   "undo", // 撤销
        //   "redo", // 重做
        //   "|",
        //   "fullScreen" // 全屏
        // ],
        excludeKeys: [
          // "bold",
          // "underline",
          // "italic",
          // "code",
          // "color",
          // "bgColor",
          // "insertLink",
          // "insertVideo",
          // "blockquote",
          // "sub"
        ]
      },
      editorConfig: {
        placeholder: _ts.placeholder,
        hoverbarKeys: {
          image: {
            // 清空 image 元素的 hoverbar
            menuKeys: [],
          },
          text: {
            menuKeys: [],
          }
        },
        MENU_CONF: {
          uploadImage: {
            server: "/api/upload", //上传地址
            maxFileSize: 500 * 1024 * 1024, //图片大小限制 (500M)

            // 自定义上传
            async customUpload(file, insertFn) {
              // file 即选中的文件
              _ts.isFileTypeFn([file]);

              if (_ts.fileTypeLock) {
                _ts.$message.error("上传附件格式不对!");
                return;
              }

              _ts.tis = _ts.$message({
                showClose: true,
                duration: 0,
                message: "图片上传中...",
                type: "warning",
              });

              for (let item of [file]) {
                await _ts.uploadNow(item);
              }
              // // 自己实现上传，并得到图片 url alt href
              // // 最后插入图片
              setTimeout(() => {
                // console.log(_ts.urlList)
                for (let i = 0, len = _ts.urlList.length; i < len; i++) {
                  insertFn(_ts.urlList[i]);
                }
                _ts.tis.close();
              }, 0);
              // console.log(_ts.urlList)

              // insertFn(url, alt, href)
            },
          },
          insertImage: {
            onInsertedImage(imageNode) {
              // 插入图片回调
              _ts.urlList = [];
              if (imageNode == null) return;

              const { src, alt, url, href } = imageNode;
              // console.log('inserted image', imageNode)
              // console.log('inserted image', src, alt, url, href)

              //插入图片后，监听所有图片，为其添加双击预览事件 (方法有待优化)
              // const _node = document.querySelector('.w-e-text-container')
              // _node.addEventListener('dblclick', (e) => {
              //   const target = e.target
              //   if (target.nodeName === 'IMG') {
              //     const _url = target.currentSrc
              //     // console.log(_url)
              //     _ts.$viewerApi({ images: [_url] })
              //   }
              // })
            },
          },
        },

        EXTEND_CONF: {
          mentionConfig: {
            // showModal: this.showMentionModal,
            // hideModal: this.hideMentionModal,
          },
        },
      },
    };
  },
  computed: {
    getDefaultContent() {
      return cloneDeep(this.defaultContent); // 深拷贝，重要！！！
    },
  },
  mounted() {
    if (this.isComment) {
      // 评论引用，加入@成员功能
      this.editorConfig.EXTEND_CONF.mentionConfig = {
        showModal: this.showMentionModal,
        hideModal: this.hideMentionModal,
      }

      // 将@成员菜单加入编辑器的菜单栏
      this.toolbarConfig.insertKeys = {
        index: 4,
        keys: ["customMenu1"]
      }
    }
  },
  methods: {
    onCreated(editor) {
      this.editorId = Object.seal(editor);
    },
    onChange(editor) {
      // console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
      // console.log('img', editor.getElemsByType('image')) // onChange 时获取编辑器最新内容

      this.latestContent = editor.children;
      // const contentStr = JSON.stringify(editor.children)
      // console.log(this.latestContent)
      // console.log(this.latestContent[0].children.length)

      //this.latestContent.length > 1 -- 有输入内容且内容大于一行
      //this.latestContent[0].children.length > 1  -- 没输入内容，有插入图片
      //this.latestContent[0].children[0].text !== ''   -- 有输入内容
      if (!this.isTaskDetail) {
        //如果是任务详情页，则不需要判断内容为空时hasConLock的值，保存按钮也无需置灰
        if (this.latestContent.length > 1 || this.latestContent[0].children.length > 1 || this.latestContent[0].children[0].text !== "") {
          this.hasConLock = false;
        } else {
          this.hasConLock = true;
        }
      }

      this.$emit("change");
      // const html = editor.getHtml()
    },
    showMentionModal() {
      this.isShowModal = true
    },
    hideMentionModal() {
      this.isShowModal = false
    },
    insertMention(id, name) {
      const mentionNode = {
        type: 'mention', // 必须是 'mention'
        value: name + ' ',
        info: { id },
        children: [{ text: '' }], // 必须有一个空 text 作为 children
      }
      const editor = this.editorId
      if (editor) {
        editor.restoreSelection() // 恢复选区
        editor.deleteBackward('character') // 删除 '@'
        editor.insertNode(mentionNode) // 插入 mention
        editor.move(1) // 移动光标
      }
      if (this.isShowModal) {
        this.isShowModal = false
      }
    },
    handleSubmit() {
      if(this.loading) return
      if (!this.isTaskDetail) {
        //如果不为任务详情页
        // hasConLock 为true 证明编辑器内无内容
        if (this.hasConLock) return;
      }

      // 如若初始显示内容跟最终内容一致，则也return false
      // if (this.textInfo === JSON.stringify(this.latestContent)) return
      let editor = this.editorId;
      const _con = JSON.stringify(editor.children);

      // 获取所有被@的成员的uid数组
      const _uidArr = this.isComment ? this.handleRecurrenceFn(editor.children) : []
      // console.log(_con, this.isComment, _uidArr, 111)
      this.$emit("editorSubmit", _con, editor.getHtml(), editor.getText(), _uidArr);
    },
    // 递归数组寻找mention的type的方法
    handleRecurrenceFn(arr) {
      let result = []

      for (let i = 0; i < arr.length; i++) {
        const obj = arr[i]

        if (obj.type === 'mention') {
          result.push(obj.info.id);
        }

        if (obj.children && obj.children.length > 0) {
          const childrenResult = this.handleRecurrenceFn(obj.children)
          result = result.concat(childrenResult)
        }
      }
      return result
    },
    handleCancel() {
      this.$emit("editorCancel");
    },
    handleImgView() {
      //监听所有图片，为其添加双击预览事件 (方法有待优化)
      const _ts = this;
      const target = event.target;
      if (target.nodeName === "IMG") {
        const _url = target.currentSrc;
        _ts.$viewerApi({ images: [_url] });
      }
    },

    isFileTypeFn(fileList) {
      const _ts = this;
      _ts.fileTypeLock = false;

      for (let i = 0, len = fileList.length; i < len; i++) {
        const _type = fileList[i].name.slice(fileList[i].name.lastIndexOf(".") + 1);
        if (_ts.fileType.indexOf(_type.toLowerCase()) < 0) {
          _ts.fileTypeLock = true;
          break;
        }
      }
    },
    async uploadNow(file) {
      let _this = this;
      try {
        const _data = {
          attachment_name: file.name,
        };
        const res = await uploadApi.getEditPolicy(_data);
        if (res) {
          let dataset = new FormData();
          dataset.append("x-oss-object-acl", `public-read`);
          dataset.append("name", res.oss_attachment_name);
          dataset.append("key", res.dir + res.oss_attachment_name);
          dataset.append("policy", res.policy);
          dataset.append("OSSAccessKeyId", res.accessid);
          dataset.append("success_action_status", "200");
          dataset.append("callback", res.callback);
          dataset.append("Content-Disposition", `attachment; filename="${file.name}"`);
          dataset.append("signature", res.signature);
          dataset.append("file", file.raw || file);
          let httpDefaultOpts = {
            baseURL: "",
            method: "post",
            cache: false,
            url: process.env.NODE_ENV === "development" ? "airworthiness_certified" : res.host,
            timeout: 0,
            data: dataset,
            headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
          };
          // console.log(httpDefaultOpts)
          let result = await instance(httpDefaultOpts);
          const resStr = result.data.data.editor_attachment;
          // return resStr
          _this.urlList.push(resStr);
          // _this.editorConfig.MENU_CONF['uploadImage'].customUpload = function(files, insertFn) {
          //   insertFn(resStr)
          // }
          // console.log(_this.urlList)
          // this.getFileUrl(fileObj, result.data.data, file)
        }
      } catch (error) {
        // this.delFilesList()
        console.log(error);
      }
    },
    onBlur() {
      const editor = this.editorId;
      const _con = JSON.stringify(editor.children);
      this.$emit("blur", _con, editor.getHtml(), editor.getText());
    },
  },
  beforeDestroy() {
    const editor = this.editorId;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.editor-wrap {
  width: 100%;
  .editor-con {
    border-radius: 4px;
    border: 1px solid rgba(13, 31, 60, 0.4);
    overflow: auto;
    position: relative;
    .isComment {
      .w-e-toolbar {
        .w-e-bar-item:nth-child(5) {
          button {
            font-size: 16px;
            padding-top: 3px;
          }
        }
      }
    }
  }
  .wrap-top {
    position: absolute;
    top: 5px;
    right: 24px;
    margin-top: 0 !important;
  }
  .button-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .wf-button + .wf-button {
      margin-left: 16px;
    }
    .el-button {
      width: 88px;
      &.el-button--default {
        &:hover {
          color: rgba(32, 32, 32, 0.6);
          background: #f7f8f9;
          border: 1px solid rgba(32, 32, 32, 0.16);
        }
        &:focus,
        &:active {
          color: #0d1f3c;
          background: #eaebec;
          border: 1px solid rgba(32, 32, 32, 0.16);
        }
      }
    }
  }
  .wrap-bottom{
    height: 64px;
    padding: 0 24px;
    border-top: 1px solid #E5E6E8;
    span{
      line-height: 48px;
    }
  }
}
</style>

<style lang="scss">
.w-e-bar {
  padding: 0;
}
.w-e-text-container ul li {
  list-style: disc;
}
.w-e-text-container ol li {
  list-style: decimal;
}
.w-e-text-container *,
.w-e-toolbar * {
  line-height: 1;
}
.w-e-text-container .w-e-scroll p {
  text-align: initial;
}
.w-e-text-container [data-slate-editor] {
  padding: 0 8px;
}
.w-e-text-container [data-slate-editor] p {
  margin: 8px 0;
}
.w-e-text-placeholder {
  top: 8px;
}
//图片的四角拖拽缩放按钮隐藏 以此暂时解决禁止此编辑器内禁止拖拽缩放功能
.w-e-image-dragger {
  display: none;
}
// .w-e-bar-item-menus-container,
// .w-e-select-list {
//   left: auto !important;
//   top: auto !important;
//   position: fixed !important;
//   margin-top: 210px !important;
// }
.w-e-bar-item-menus-container .w-e-bar-item button{
  justify-content: flex-start;
  width: 100%;
}
.w-e-toolbar {
  display: flex;
  flex-wrap: inherit;
  width: 100%;
}
// .w-e-menu-tooltip-v5:before {
//   position: fixed;
//   left: auto;
//   top: auto;
//   margin-top: 61px;
// }
// .w-e-menu-tooltip-v5:after {
//   position: fixed;
//   left: auto;
//   top: auto;
//   margin-top: 30px;
// }
</style>
